import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { DynamicFlowProvider } from 'components/common/DynamicFlow'
import React from 'react'
import { SignupRegistrationController } from './SignupRegistration.controller'
import { SignupRegistrationProvider } from './SignupRegistration.context'

/**
 * Page representing the overall signup registration content.
 *
 * @example <SignupRegistration />
*/
export const SignupRegistration: React.FC = () => {

  return (
    <BKBNThemeWrapper>
      <DynamicFlowProvider>
        <SignupRegistrationProvider>
          <SignupRegistrationController />
        </SignupRegistrationProvider>
      </DynamicFlowProvider>
    </BKBNThemeWrapper>
  )
}
